import React from 'react'
import styled from 'styled-components'

import { white, black } from 'styles/colors'
import { cover } from 'styles/global'
import { media } from 'styles/media'

const Container = styled.div`
  background-color: ${black};
  border: 0.3em solid ${white};
`

const FigureWrap = styled.div`
  position: relative;

  &:after {
    content: '';
    display: block;
    padding-bottom: 35.5%;

    ${media.small`
      padding-bottom: 11.2%;
    `};
  }
`

const Figure = styled.img`
  object-fit: cover;
  max-width: none;
  ${cover('absolute')};
`

const HealthWarning = () => (
  <Container>
    <FigureWrap>
      <Figure src={`${process.env.BASE_PATH}/images/misc/health-warning-mobile.svg`} className="u-hide-small-up" />
      <Figure src={`${process.env.BASE_PATH}/images/misc/health-warning-desktop.svg`} className="u-hide-small-down" />
    </FigureWrap>
  </Container>
)

export default HealthWarning
